export const ProjectData = [
  {
    url: "https://weather-app-eosin-three-62.vercel.app",
    title: "Weather App", //w
    img: require("./assets/weather-app.webp"),
    alt: "Weather App",
    stack: ["React", "Tailwind CSS", "OpenWeatherMap API"],
    description: "A weather app that shows the weather of any city in realtime",
  },
  // {
  //   url: "https://root-017.github.io/Trivial-Question-Web-App/",
  //   title: "Trivial Question Web-App", 
  //   img: require("./assets/trivial-question-web-app.webp"),
  //   alt: "Trivial-Question-Web-App",
  //   stack: ["HTML", "CSS", "JavaScript"],
  //   description:
  //     "This is a web application that the give quizes about countries and their capitals",
  // },
  {
    url: "https://github.com/ROOT-017/Online-Furnicture-Store",
    title: "Online Furnicture Store",
    img: require("./assets/online-furnicture-store.webp"),
    alt: "Online-Furnicture-Store",
    stack: ["HTML", "CSS", "JavaScript"],
    description:
      "Online Furniture Store, as the name entitle is a web application that provides a platform for users to buy furniture online.",
  },
  {
    url: "https://root-017.github.io/Web-Music-App/",
    title: "Web Music App",
    img: require("./assets/web-music-app.webp"),
    alt: "Web Music App",
    stack: ["HTML", "CSS", "JavaScript"],
    description:
      "Web Music App is a web application that allows users to listen to music online. There is a selected playlist which contain songs of different genres for every individual.",
  },
  // {
  //   url: "https://github.com/ROOT-017/BrickBreaker",
  //   title: "Brick Breaker Game (Java)",
  //   img: require("./assets/work11.jpg"),
  //   alt: "Brick Breaker",
  //   stack: ["Java"],
  //   description:
  //     "Brick Breaker is a game developed using Java., This age is a basic game that has a ball and a paddle. The ball bounces off the paddle and the walls. The objective of the game is to break all the bricks in the map.",
  // },
  {
    url: "https://natours-app-iq7e.onrender.com/",
    title: "Natours Tour App", //natours-tour-app
    img: require("./assets/natours-tour-app.webp"),
    alt: "Natours Tour App",
    stack: ["Node.js", "Express.js", "Pug.js", "Mailjet"],
    description:
      "Natour API, it a full and complete RESTful api for booking and managing tours in the US. This api provide endpoints for various resources such as booking a tour, viewing available tours, difficulty of each tour availabe people for each tours and so much more. This API is build with Node.js/Express.js and has a well organize database with MongoDB ",
  },

  {
    url: "https://ecommerceshopp.vercel.app/",
    title: "E-Commerce",
    img: require("./assets/e-commerce.webp"),
    alt: "E-Commerce",
    stack: [
      "React",
      "Redux",
      "Firebase",
      "Stripe",
      "Tailwind CSS",
      "TypeScript",
      "DummyJSON API",
    ],
    description:
      "An ecommerce platform powered bu DUMMYJSON API, That provide basic of an e-commerce platform like add to card and drop or clear cart, with advanced feauture such as google authentication and processing payments with stripe. This project is highly scalable and can be used as a template for any ecommerce platform.",
  },
  {
    url: "https://eagle-chat.vercel.app/",
    title: "Eagle Chat App", //eagle-chat-app
    alt: "Eagle Chat App",
    img: require("./assets/eagle-chat-app.webp"),
    stack: ["Next.js", "Ably", "Tailwind CSS"],
    description:
      " Eagle chat is a chating application that enable conected github users of the platform to exchang text messages. This appliction is power by Vercel and Ably. Authentication is required to use the apltform and authentiction with Github is supported",
  },
  {
    url: "https://intelli-academy.vercel.app/",
    title: "Intelli Academy",
    alt: "Intelli Academy",
    img: require("./assets/intelli-academy.webp"),
    stack: [
      "Vue.js",
      "TypeScript",
      "Node.js",
      "Express.js",
      "Tailwind CSS",
      "Pug.js",
      "Mailjet",
      "MongoDB",
    ],
    description: "",
  },
  // {
  //   url: "https://github.com/ROOT-017/",
  //   title: "More",
  //   img: require("./assets/work6.jpg"),
  //   alt: "Web Music App",
  // },
];
